import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook'
import Button from 'components/shared/Button/Button'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import './EditorSlice.scss'
import sliceImage from './images/editor.png'

const EditorSlice = ({ slug, locale, t, gtm = {} }) => {
  const sendDataToGTM = useGTMDispatch()
  const handleClick = () => sendDataToGTM({ ...gtm, label: 'Editor slice' })

  const hrefWithEditor = `/${locale}/projects/editor-${slug}/editor`
  const hrefWithNoEditor = `/${locale}/projects/${slug}/editor`

  return (
    <div className="editor-slice__wrapper">
      <div className="editor-slice">
        <div className="editor-slice__copy">
          <ul className="editor-slice__beta-tag">
            <li className="editor-slice__tag">
              {t('project.editor-slice.tag')}
            </li>
          </ul>
          <h3>{t('project.editor-slice.title')}</h3>
          <p>{t('project.editor-slice.description')}</p>
          <Button
            type="primary"
            text={t('project.editor-slice.button')}
            href={slug.includes('editor') ? hrefWithNoEditor : hrefWithEditor}
            onClick={handleClick}
          />
        </div>
        <img
          alt="Editor slice"
          className="editor-slice__image"
          src={sliceImage}
        />
      </div>
    </div>
  )
}

EditorSlice.propTypes = {
  t: PropTypes.func.isRequired,
  gtm: PropTypes.object,
  slug: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
}

export { EditorSlice }
export default withTranslation('translations')(EditorSlice)
